import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { CommonProperties, Color } from '../../styles';
import RowView from '../RowView';
import Icon from '../Icon';
import StopInfo from './StopInfo';
import SlideTitle from './SlideTitle';
import { scale } from '../../utils/scale.utils';

const Slide = ({
  image,
  type,
  name,
  detail,
  status,
  startLabel,
  startTime,
  startDetail,
  endLabel,
  endTime,
  endDetail,
  children,
}) => {
  return (
    <View style={styles.container}>
      <SlideTitle image={image} type={type} name={name} detail={detail} status={status} />
      <RowView style={styles.innerContainer}>
        <StopInfo type={startLabel} time={startTime} detail={startDetail} />
        <StopInfo type={endLabel} time={endTime} detail={endDetail} />
        <View style={styles.arrowRightFloat}>
          <TouchableOpacity
            onPress={() => {
              // TODO: Move to the next slide
            }}
          >
            <Icon style={styles.chevronRight} color={Color.primary} name="chevronRight" />
          </TouchableOpacity>
        </View>
      </RowView>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    ...CommonProperties.p4,
    paddingTop: scale(24),
  },
  innerContainer: {
    ...CommonProperties.py3,
  },
  chevronRight: {
    color: Color.accent,
    fontSize: scale(28),
  },
  arrowRightFloat: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    justifyContent: 'center',
  },
});

export default Slide;
